var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location-pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.347,
    height: 19.299,
    viewBox: "0 0 14.347 19.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M15.994,8.971a2.64,2.64,0,1,0,2.64,2.64A2.64,2.64,0,0,0,15.994,8.971Zm0,3.96a1.32,1.32,0,1,1,1.32-1.32,1.32,1.32,0,0,1-1.32,1.32Z",
    transform: "translate(-8.821 -4.434)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M17.872,3.337A7.174,7.174,0,0,0,6.789,12.326l4.987,7.656a1.222,1.222,0,0,0,2.047,0l4.988-7.656a7.174,7.174,0,0,0-.938-8.988ZM17.7,11.606l-4.9,7.53-4.9-7.53a5.854,5.854,0,1,1,9.81,0Z",
    transform: "translate(-5.627 -1.238)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdLocationIcon);
export default __webpack_public_path__ + "static/media/ad-location-icon.2f549d24533242d0744cec254e98551f.svg";
export { ForwardRef as ReactComponent };